/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Input} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {
  clientTypesOptions,
  operatingRegions,
  organizationalTools,
} from '@gatewee/types/onboarding';

@Component({
  selector: 'app-business-profile-form',
  templateUrl: './business-profile-form.component.html',
  styleUrls: ['./business-profile-form.component.css'],
  standalone: false,
})
export class BusinessProfileFormComponent {
  @Input() formGroup!: FormGroup;

  clientTypes = clientTypesOptions;
  operatingRegions = operatingRegions;
  organizationalTools = organizationalTools;

  constructor(private fb: FormBuilder) {}

  onCheckboxChange(event: any, controlName: string) {
    const formArray: FormArray = this.formGroup.get(controlName) as FormArray;
    if (event.target.checked) {
      formArray.push(this.fb.control(event.target.value));
    } else {
      const index = formArray.controls.findIndex(
        x => x.value === event.target.value,
      );
      formArray.removeAt(index);
    }
  }

  isChecked(controlName: string, value: string): boolean {
    const formArray: FormArray = this.formGroup.get(controlName) as FormArray;
    return formArray.value.includes(value);
  }
}
